export const environment = {
    production: false,
    label: 'local',
    // API_GATEWAY_URL: 'https://dev-api.bciti.info',
    API_GATEWAY_URL: 'http://localhost:3000',
};
